import Link from 'next/link'

interface AffiliateDisclaimerProps {
    url: string
}

export function AffiliateDisclaimer({ url }: AffiliateDisclaimerProps) {
    return (
        <div className='pb-4'>
            <div className='border-l-2 border-accent pl-2'>
                Commerce Content is independent of Editorial and Advertising, and if you buy something through our posts, we may get a small share of the sale.{' '}
                <Link href={url} aria-label='More information on commerce content' className='text-accent'>
                    Click here
                </Link>{' '}
                for more.
            </div>
        </div>
    )
}
